<section id="section-report" class="container-fluid mt-lg-2">
  <div class="row">
    <div id="container-print" class="col-12 col-lg-12">
      <table id="main-container-print" class="mt-1">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{maintenanceOrderPrintModel.maintenanceOrderId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{maintenanceOrderPrintModel.maintenanceOrderId}}" [src]="logoEnterprise" alt=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">

                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintModel.enterpriseName}}</p>

                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintModel.branchName}}</p>

                  <!--Clase de Orden de Mantenimiento -->
                  <p id="orden-mantenimiento-clase-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">ORDEN DE MANTENIMIENTO EN TALLER</p>

                  <!-- Orden de Mantenimiento Consecutivo -->
                  <label id="t-orden-mantenimiento-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-orden-mantenimiento' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="orden-mantenimiento-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintModel.consecutive}}
                  </p>

                  <!-- Orden de Mantenimiento Fecha -->
                  <label id="t-orden-mantenimiento-fecha-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-orden-mantenimiento-fecha' | formatLabelPipe : elementsLabel}}</label>
                  <p id="orden-mantenimiento-fecha-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintModel.dateMaintenanceOrder | date: 'dd/MM/yyyy'}}</p>

                  <!-- Orden de Mantenimiento Tipo -->
                  <label id="t-orden-mantenimiento-tipo-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-orden-mantenimiento-tipo' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="orden-mantenimiento-tipo-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintModel.typeMaintenanceOrder}}
                  </p>

                  <!-- Cliente -->
                  <label id="t-cliente-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-cliente' | formatLabelPipe : elementsLabel}}</label>
                  <p id="cliente-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{maintenanceOrderPrintModel.clientName}}</p>

                  <!-- Dirección Cliente -->
                  <label id="t-direccion-cliente-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-direccion-cliente' | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-cliente-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintModel.clientAddress}}</p>

                  <!--Teléfono Cliente -->
                  <label id="t-telefono-cliente-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-telefono-cliente' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-cliente-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintModel.clientPhone}}</p>

                  <!-- Centro de Costos  -->
                  <label id="t-centro-costos-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-centro-costos' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="centro-costos-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintModel.costCenterName}}</p>

                  <!-- Obra  -->
                  <label id="t-obra-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-obra' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="obra-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{maintenanceOrderPrintModel.constructionSiteName}}</p>

                  <!-- Dirección Obra  -->
                  <label id="t-direccion-obra-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-direccion-obra' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="direccion-obra-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintModel.constructionSiteAddress}}</p>

                  <!-- Teléfono Obra -->
                  <label id="t-telefono-obra-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-telefono-obra' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-obra-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintModel.constructionSitePhone}}</p>

                  <!-- Mecánico  -->
                  <label id="t-mecanico-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-mecanico' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="mecanico-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintModel.mechanicName}}</p>

                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div id="body-{{maintenanceOrderPrintModel.maintenanceOrderId}}" class="body">
                <!-- Equipo -->
                <label id="t-equipo-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-equipo' | formatLabelPipe : elementsLabel}}</label>
                <p id="equipo-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{maintenanceOrderPrintModel.equiptmentName}}</p>

                <!-- Equipo Código  -->
                <label id="t-equipo-codigo-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-equipo-codigo' | formatLabelPipe : elementsLabel}}
                </label>
                <p id="equipo-codigo-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{maintenanceOrderPrintModel.equiptmentCode}}</p>

                <!-- Equipo Marca -->
                <label id="t-marca-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-marca' | formatLabelPipe : elementsLabel}}</label>
                <p id="marca-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{maintenanceOrderPrintModel.trademark}}</p>

                <!-- Equipo Referencia -->
                <label id="t-referencia-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-referencia' | formatLabelPipe : elementsLabel}}</label>
                <p id="referencia-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{maintenanceOrderPrintModel.reference}}</p>

                <!-- Equipo Serie -->
                <label id="t-serie-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-serie' | formatLabelPipe : elementsLabel}}</label>
                <p id="serie-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{maintenanceOrderPrintModel.serie}}</p>

                <!-- Equipo Nombre Comercial -->
                <label id="t-nombre-comercial-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-nombre-comercial' | formatLabelPipe : elementsLabel}}</label>
                <p id="nombre-comercial-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{maintenanceOrderPrintModel.commercialName}}</p>

                <!-- Equipo Tipo Equipo -->
                <label id="t-tipo-equipo-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-tipo-equipo' | formatLabelPipe : elementsLabel}}</label>
                <p id="tipo-equipo-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{maintenanceOrderPrintModel.equiptmentType}}</p>

                <!-- Equipo Tipo Motor -->
                <label id="t-tipo-motor-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-tipo-motor' | formatLabelPipe : elementsLabel}}</label>
                <p id="tipo-motor-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{maintenanceOrderPrintModel.engineType}}</p>

                <!-- Equipo Voltaje -->
                <label id="t-voltaje-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-voltaje' | formatLabelPipe : elementsLabel}}</label>
                <p id="voltaje-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{maintenanceOrderPrintModel.voltage}}</p>

                <!-- Equipo Potencia -->
                <label id="t-potencia-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-potencia' | formatLabelPipe : elementsLabel}}</label>
                <p id="potencia-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{maintenanceOrderPrintModel.power}}</p>

                <!-- Equipo Amperaje -->
                <label id="t-amperaje-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-amperaje' | formatLabelPipe : elementsLabel}}</label>
                <p id="amperaje-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{maintenanceOrderPrintModel.amperage}}</p>

                <!-- Orden de Mantenimiento Diagnóstico Inicial -->
                <label id="t-diagnostico-inicial-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-diagnostico-inicial' | formatLabelPipe : elementsLabel}}</label>
                <p *ngIf="!onBlank" id="diagnostico-inicial-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{maintenanceOrderPrintModel.initialDiagnosis}}</p>
                <p id="fecha-diagnostico-inicial-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{maintenanceOrderPrintModel.dateInitialMaintenanceOrder | date: 'dd/MM/yyyy'}}</p>
                <p id="borde-diagnostico-inicial-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                <!-- Orden de Mantenimiento Diagnóstico Final -->
                <label id="t-diagnostico-final-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-diagnostico-final' | formatLabelPipe : elementsLabel}}</label>
                <p *ngIf="!onBlank" id="diagnostico-final-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{maintenanceOrderPrintModel.finalDiagnosis}}</p>
                <p *ngIf="!onBlank" id="fecha-diagnostico-final-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{maintenanceOrderPrintModel.dateFinalMaintenanceOrder | date: 'dd/MM/yyyy'}}</p>
                <p id="borde-diagnostico-final-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

              </div>
              <div id="foot-{{maintenanceOrderPrintModel.maintenanceOrderId}}" class="foot mt-3">
                <!-- Linea Footer -->
                <p id="linea-footer-{{maintenanceOrderPrintModel.maintenanceOrderId}}" class="write-line"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                <!-- Orden de Mantenimiento Conductor -->
                <label id="t-conductor-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-conductor' | formatLabelPipe : elementsLabel}}
                </label>
                <p id="conductor-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{maintenanceOrderPrintModel.driver}}
                </p>

                <!-- Orden de Mantenimiento Vehiculo -->
                <label id="t-vehiculo-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-vehiculo' | formatLabelPipe : elementsLabel}}
                </label>
                <p id="vehiculo-{{maintenanceOrderPrintModel.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{maintenanceOrderPrintModel.vehicle}}
                </p>

                <!-- Orden de Mantenimiento Valor Transporte -->
                <label id="t-valor-transporte-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-valor-transporte' | formatLabelPipe : elementsLabel}}
                </label>
                <p id="valor-transporte-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{maintenanceOrderPrintModel.transportValue}}
                </p>

                <!-- Observaciones -->
                <label id="t-observacion-manual-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-observacion-manual' | formatLabelPipe : elementsLabel}}</label>

                <!-- Autorizado por -->
                <label id="t-autorizado-por-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-autorizado-por' | formatLabelPipe : elementsLabel}}</label>

                <!-- Firma Cliente -->
                <label id="t-firma-cliente-{{maintenanceOrderPrintModel.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-firma-cliente' | formatLabelPipe : elementsLabel}}</label>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot id="td-foot">
          <tr>
            <td colspan="2">
              <div [ngClass]="paperSize == paperSizeFormat ? 'footer' : ''" class="informationPrint d-flex"
                class="informationPrint d-flex">
                <!-- Versión-->
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>

                <!-- Fecha Impresión-->
                <label id="t-fecha-impresion" class="fw-bold pe-2">
                  {{'t-fecha-impresion' | formatLabelPipe : elementsLabel}}</label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>

                <!-- Hora Impresión-->
                <label id="t-hora-impresion" class="fw-bold pe-2">
                  {{'t-hora-impresion' | formatLabelPipe : elementsLabel}}</label>
                <p id="hora-impresion" class="pe-4">{{dateNow | date: 'hh:mm:ss a'}}</p>

                <!-- Usuario Impresión-->
                <label id="t-usuario-impresion" class="fw-bold pe-2">
                  {{'t-usuario-impresion' | formatLabelPipe : elementsLabel}}</label>
                <p id="usuario-impresion" class="pe-4">{{maintenanceOrderPrintModel.userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 informationPrint">Documento generado con el Software Cervino Web de Altos Software SAS.
                    Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>